import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { gwasListSelector } from "../../../../state/selectors/GWASComponent.selectors";
import CardWrapper from "../../CardWrapper";
import Card from "../../Card";

const GwasCard = ({ card, gwasList }) => {
  const isDisabled = !Object.keys(gwasList || {}).length;

  return (
    <CardWrapper
      {...card}
      isDisabled={isDisabled}
      color={gwasList.length ? "red" : null}
    >
      {gwasList.length ? (
        <div>
          <div className="tw-font-bold" data-testid="gwas-content">
            {gwasList[0].diseaseOrTrait}
            <br />
            {gwasList[0].pValue}
          </div>
        </div>
      ) : null}
    </CardWrapper>
  );
};

GwasCard.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  gwasList: PropTypes.arrayOf(PropTypes.any),
  card: PropTypes.instanceOf(Card).isRequired,
};

GwasCard.defaultProps = {
  gwasList: [],
};

const mapStateToProps = (state) => ({
  gwasList: gwasListSelector(state),
});

export default connect(mapStateToProps)(GwasCard);
